/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import ModalExample from '../examples/Modal';
import ModalBackdropExample from '../examples/ModalBackdrop';
import ModalCustomTimeoutExample from '../examples/ModalCustomTimeout';
import ModalFadelessExample from '../examples/ModalFadeless';
import ModalCustomCloseButtonExample from '../examples/ModalCustomCloseButton';
import ModalFocusAfterClose from '../examples/ModalFocusAfterClose';
import ModalWithoutHeaderExample from '../examples/ModalWithoutHeader';
const ModalBackdropExampleSource = require('!!raw-loader!../examples/ModalBackdrop');
const ModalCustomCloseButtonExampleSource = require('!!raw-loader!../examples/ModalCustomCloseButton');
const ModalCustomTimeoutExampleSource = require('!!raw-loader!../examples/ModalCustomTimeout');
const ModalExampleSource = require('!!raw-loader!../examples/Modal');
const ModalFadelessExampleSource = require('!!raw-loader!../examples/ModalFadeless');
const ModalFocusOnDestroyExampleSource = require('!!raw-loader!../examples/ModalFocusAfterClose');
const ModalWithoutHeaderExampleSource = require('!!raw-loader!../examples/ModalWithoutHeader');
const ModalsPage = () => {
    return (<div>
            <Helmet title="Modals"/>
            <div className="docs-example">
                <div className="btn-group">
                    <div className="btn">
                        <ModalExample buttonLabel="Launch Modal"/>
                    </div>
                    <div className="btn">
                        <ModalExample buttonLabel="Launch Modal with custom className" className="my-custom-modal"/>
                    </div>
                </div>
            </div>
            <pre>
                <PrismCode className="language-jsx">{ModalExampleSource}</PrismCode>
            </pre>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`
type TransitionType = {
  mountOnEnter?: boolean,
  timeout: number,
};

type Props = {|
  isOpen: boolean,
  size: ?string,
  toggle: ?Function,
  children: Node,
  backdrop: boolean | 'static',
  fade: boolean,
  withoutHeader: boolean,
  returnFocusAfterClose: boolean,
  className: ?string,
  wrapClassName: string,
  modalTransition: TransitionType,
  backdropTransition: TransitionType,
|}`}
                </PrismCode>
            </pre>

            <h4>Backdrop</h4>
            <div className="docs-example">
                <div className="btn-group">
                    <div className="btn">
                        <ModalBackdropExample buttonLabel="Launch Modal"/>
                    </div>
                </div>
            </div>
            <pre>
                <PrismCode className="language-jsx">{ModalBackdropExampleSource}</PrismCode>
            </pre>

            <h4>Modals with Custom Transition Timeouts</h4>
            <div className="docs-example">
                <div className="btn-group">
                    <div className="btn">
                        <ModalCustomTimeoutExample buttonLabel="Launch Modal with Custom Transition Timeouts Example"/>
                    </div>
                </div>
            </div>
            <pre>
                <PrismCode className="language-jsx">{ModalCustomTimeoutExampleSource}</PrismCode>
            </pre>

            <h4>Modals without Fade Effect</h4>
            <div className="docs-example">
                <div className="btn-group">
                    <div className="btn">
                        <ModalFadelessExample buttonLabel="Launch Modal without Fade Effect Example"/>
                    </div>
                </div>
            </div>
            <pre>
                <PrismCode className="language-jsx">{ModalFadelessExampleSource}</PrismCode>
            </pre>

            <h4>Modals with custom close button</h4>
            <div className="docs-example">
                <div className="btn-group">
                    <div className="btn">
                        <ModalCustomCloseButtonExample buttonLabel="Launch Modal with custom close button"/>
                    </div>
                </div>
            </div>
            <pre>
                <PrismCode className="language-jsx">{ModalCustomCloseButtonExampleSource}</PrismCode>
            </pre>

            <h4>Focus after close</h4>
            <div className="docs-example">
                <div className="btn-group">
                    <div className="btn">
                        <ModalFocusAfterClose />
                    </div>
                </div>
            </div>
            <pre>
                <PrismCode className="language-jsx">{ModalFocusOnDestroyExampleSource}</PrismCode>
            </pre>

            <h4>Modal without Header</h4>
            <div className="docs-example">
                <div className="btn-group">
                    <div className="btn">
                        <ModalWithoutHeaderExample buttonLabel="Launch Modal without Header"/>
                    </div>
                </div>
            </div>
            <pre>
                <PrismCode className="language-jsx">{ModalWithoutHeaderExampleSource}</PrismCode>
            </pre>
        </div>);
};
export default ModalsPage;
